export interface ICallApi {
  callApi: (params: { method: string; url: string; options?: any; body?: any }) => Promise<any>;
}

export interface IFieldVersion {
  lastEditor?: string;
  lastEditorId?: string;
  operation: 'INSERT' | 'UPDATE' | 'DELETE' | 'TRUNCATE';
  timestamp: string;
  value: unknown;
}

export interface IFieldVersionsPage {
  cursor?: string;
  items: IFieldVersion[];
}

// zeus-backend exposes these as generic mixins on every `versioned` CRUD table (and on the
// linked `settings` sub-resource): GET <resource>/_fieldversions?path=... and
// POST <resource>/_versions/_revert. The SDK's getChild/createChild only allow child types it
// has pre-registered (readme, _versions, settings, ...), so these are called via the SDK's
// lower-level callApi escape hatch instead -- same approach already used in
// src/api/extractionCells/extractionCellMetrics.api.ts for another endpoint the SDK doesn't model.
export const fetchFieldVersions = async (
  api: ICallApi,
  resourceId: string,
  childPath: string | undefined,
  fieldPath: string,
  cursor?: string,
  limit = 20,
): Promise<IFieldVersionsPage> => {
  const url = childPath ? `${resourceId}/${childPath}/_fieldversions` : `${resourceId}/_fieldversions`;

  try {
    const response = await api.callApi({
      method: 'GET',
      url: url,
      options: {
        queryParameters: {
          limit: limit,
          path: fieldPath,
          sortDirection: 'DESC',
          ...(cursor ? { cursor: cursor } : {}),
        },
      },
    });

    return {
      items: response?.items || [],
      cursor: response?.metadata?.cursor,
    };
  } catch (error) {
    console.error('Error fetching field version history', error);
    return { items: [], cursor: undefined };
  }
};

export const revertFieldVersion = async (
  api: ICallApi,
  resourceId: string,
  childPath: string | undefined,
  fieldPath: string,
  value: unknown,
): Promise<any> => {
  const url = childPath ? `${resourceId}/${childPath}/_versions/_revert` : `${resourceId}/_versions/_revert`;

  return api.callApi({
    method: 'POST',
    url: url,
    body: { path: fieldPath, value: value },
  });
};
